import {Controller} from "@hotwired/stimulus";
import {Turbo} from "@hotwired/turbo-rails";


/**
 * Promote a visit when it's added to the DOM,
 * meant to be as a TurboStream response from the server
 */
export default class ReloadController extends Controller {
  static values = {
    form: String,
    delay: Number,
  }

  initialize() {
    if (this.hasFormValue) {
      const form = document.querySelector("#" + this.formValue);
      if (form) {
        setTimeout(() => {
          form.requestSubmit();
        }, this.delayValue || 0);
      }
    } else {
      console.debug('RELOAD: promoting a browser reload')
      setTimeout(() => {
        Turbo.visit(location.href);
      }, this.delayValue || 0);
    }
    this.element.remove();
  }
}
